export default {
    PROPERTIES: "Свойства",
    ATTRIBUTES: "Атрибуты",
    MORE_THAN_ONE_EDGE_SELECTED: "Выбрано более одной связи"
};
